export type SkillSlot = 0 | 1 | 2 | 3;

export type GameAction =
  | { type: 'move'; axis: number }
  | { type: 'move-depth'; axis: number }
  | { type: 'attack' }
  | { type: 'pickup' }
  | { type: 'jump' }
  | { type: 'dodge' }
  | { type: 'sprint'; active: boolean }
  | { type: 'skill'; slot: SkillSlot };

export type GameActionListener = (action: GameAction) => void;

export class GameActionBus {
  private readonly listeners = new Set<GameActionListener>();
  lastAction: GameAction = { type: 'move', axis: 0 };

  emit(action: GameAction): void {
    const normalized = action.type === 'move' || action.type === 'move-depth'
      ? { ...action, axis: Math.max(-1, Math.min(1, action.axis)) }
      : action;
    this.lastAction = normalized as GameAction;
    for (const listener of this.listeners) listener(this.lastAction);
  }

  subscribe(listener: GameActionListener): () => void {
    this.listeners.add(listener);
    return () => this.listeners.delete(listener);
  }
}

export const gameActionBus = new GameActionBus();
